import { Component, OnInit } from "@angular/core";
import { User } from "../../providers";

@Component({
  selector: "app-buy-voucher-list",
  templateUrl: "./buy-voucher-list.component.html",
})
export class BuyVoucherListComponent implements OnInit {
  vouchers: any = [];

  constructor(private _user: User) {}

  ngOnInit() {
    this._user.getAvailableVouchersForPurchase().subscribe((result) => {
      this.vouchers = result.data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buy-voucher-list/buy-voucher-list.component.ts